import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImageAuto } from '../../../../../base/publicMethod/index';
import { h5PageCount } from '../../../../../utils';
import { formatVideoDuration } from '../../utils/formatVideoDuration';
import imageUrl from '../../utils/imageUrl';
import { getImageUrl } from '../../utils/image';
import Grounds from '../../../../../base/grounds';
import { WxLaunchApp } from '../../../../wxLaunchApp';

const { callApp, getSchemeLink, getWebAppLink } = require('@ifeng/callapp');

// 二图
class TwoImg extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
        countMapCache: PropTypes.object,
        isDisplaySource: PropTypes.bool,
        isCount: PropTypes.bool,
        isLazyImage: PropTypes.bool,
        observer: PropTypes.object,
    };

    static defaultProps = {
        isDisplaySource: true,
        isCount: true,
        isClickListItem: false,
        isLazyImage: true,
    };

    ref = React.createRef();

    async componentDidMount() {
        const { index, observer } = this.props;

        Array.from(this.ref.current.querySelectorAll('[data-lazy-src]')).forEach(item => {
            item.setAttribute('data-index', index);

            observer.observe(item);
        });
    }

    handleClick = (
        url,
        id,
        newstype,
        kind,
        downloads,
        clickCountConfig,
        isVideoShare,
        isSendCount = true,
        isJumpQQlink = false,
        isCallApp = true
    ) => {
        const doc_type = newstype;
        const aid = id;
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if(isSendCount) {
            this.feedClickCountFn(clickCountConfig);
        }

        if(isJumpQQlink){
            if(clickCountConfig) {
                clickCountConfig.other.tag = 't9';
                this.feedClickCountFn(clickCountConfig);
            }
        }

        if(isCallApp) {
            callApp({
                client,
                docType: doc_type,
                pid: aid,
                kind,
                download: downloads && downloads.download,
                downloadAd: downloads && downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink
            });
        }
    };

    feedClickCountFn = config => {
        if (window.grounds) return Grounds.jumpInNative(this.props.item);

        if (config) {
            h5PageCount([config]);
        }
    };

    render() {
        let { item, isLazyImage } = this.props;

        if (typeof window === 'object' && window.grounds) url = null;

        const twoImgBox = item.data.map((data, index) => {
            let {
                title,
                id,
                _id,
                url,
                type,
                callUp,
                newstype,
                clickCount,
                kind,
                downloads,
                thumbnail,
                thumbnails,
                duration,
                isVideoShare,
                wxLaunchSwitch,
                wxLaunchType
            } = data;
            const clickCountConfig = clickCount ? clickCount : '';

            let image = thumbnail && thumbnail !== '' ? thumbnail : thumbnails;

            id = _id || id;
            // thumbnails
            if (image && typeof image === 'object' && 'image' in image) {
                image = getImageUrl(image.image[0]);
            }

            const src = formatImageAuto(image, 336, 186);

            const props = {};

            if (isLazyImage) {
                props.src = imageUrl.middle;
                props['data-lazy-src'] = formatImageAuto(src, 336, 186);
            } else {
                props.src = src;
            }

            const schemeLink = wxLaunchType === 'weapp' ? 
                                getWebAppLink({
                                    docType: newstype || 'doc',
                                    pid: id,
                                }) : getSchemeLink({
                                    docType: newstype || 'doc',
                                    pid: id,
                                    kind
                                });

            return callUp ? (
                <div
                    key={index}
                    className={styles.twoPicItem}
                    onClick={
                        this.handleClick.bind(
                            this,
                            url,
                            id,
                            newstype,
                            kind,
                            downloads,
                            clickCountConfig,
                            isVideoShare
                        )
                    }>
                    <div className={styles.picBox}>
                        <img className={styles.pic} {...props} />
                        {type === 'video' || type === 'miniVideo' ? (
                            <Fragment>
                                <span className={styles.playIcon} />
                                {duration && (
                                    <span className={styles.videoIcon}>
                                        <span />
                                        <span>{formatVideoDuration(Number(duration))}</span>
                                    </span>
                                )}
                            </Fragment>
                        ) : (
                            ''
                        )}
                    </div>
                    {callUp === 1 && <p className={styles.mark}>打开APP阅读</p>}
                    <div className={styles.txt}>{title}</div>
                    {!isVideoShare && wxLaunchSwitch && <WxLaunchApp
                            launchType={wxLaunchType}
                            launchAppClick={this.handleClick.bind(
                                this,
                                url,
                                id,
                                newstype,
                                kind,
                                downloads,
                                clickCountConfig,
                                isVideoShare,
                                true,
                                false,
                                false,
                            )}
                            schemeLink={schemeLink}
                            launchAppFail={this.handleClick.bind(
                                this,
                                url,
                                id,
                                newstype,
                                kind,
                                downloads,
                                clickCountConfig,
                                isVideoShare,
                                false,
                                true,
                                true,
                            )}
                        />}
                </div>
            ) : (
                <a
                    key={index}
                    onClick={this.feedClickCountFn.bind(this, clickCountConfig)}
                    className={styles.twoPicItem}
                    href={url}>
                    <div className={styles.picBox}>
                        <img className={styles.pic} {...props} />
                        {type === 'video' || type === 'miniVideo' ? (
                            <Fragment>
                                <span className={styles.playIcon} />
                                {duration && (
                                    <span className={styles.videoIcon}>
                                        <span />
                                        <span>{formatVideoDuration(Number(duration))}</span>
                                    </span>
                                )}
                            </Fragment>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className={styles.txt}>{title}</div>
                </a>
            );
        });

        return (
            <div className={styles.twoImg} ref={this.ref}>
                {twoImgBox}
            </div>
        );
    }
}

export default TwoImg;
